// extracted by mini-css-extract-plugin
export default {"first":"#0a4d28","productTextBody":"Deska_podlogowa_productTextBody__iy64E","green":"Deska_podlogowa_green__L2T5t"};